import { axios } from '@/utils/request'

/**
 * 1、查询体检套餐
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medComboPage (parameter) {
  return axios({
    url: '/buMedicalCombo/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 2、获取单个体检套餐详情
 * @author LIWEI
 * @date 2022-04-12 15:21:29
 */
export function medComboProjectPage (parameter) {
  return axios({
    url: '/buMedicalComboProject/page',
    method: 'get',
    params: parameter,
  })
}

/**
 * @Description: 3、发布、恢复、下架 体检套餐
 * @author wanglong
 * @date 2024/10/28 10:51
 */
export function updateExamComboState(params) {
  return axios({
    url: '/buMedicalCombo/updateExamComboState',
    method: 'post',
    data: params
  })
}

/**
 * @Description: 4、获取体检单项集合
 * @author wanglong
 * @date 2024/10/28 13:36
 */
export function qryExamProjectList(params) {
  return axios({
    url: '/baMedicalProject/qryExamProjectList',
    method: 'post',
    data: `gender=${params}`
  })
}

/**
 * @Description: 5、新增体检套餐
 * @author wanglong
 * @date 2024/10/28 14:09
 */
export function addExamCombo (params) {
  return axios({
    url: '/buMedicalCombo/add',
    method: 'post',
    data: params
  })
}

/**
 * @Description: 5、修改体检套餐
 * @author wanglong
 * @date 2024/10/28 17:09
 */
export function editExamCombo (params) {
  return axios({
    url: '/buMedicalCombo/edit',
    method: 'post',
    data: params
  })
}

export function medComboExport(params) {

}
